(function(){
  'use strict';

  /* ---------- Product / variant data (page produit uniquement) ---------- */
  var variantsEl = document.getElementById('product-variants-json');
  var variants = [];
  var productMeta = window.BossSecretProduct || { colorOptionIndex: -1, sizeOptionIndex: -1 };
  if(variantsEl){
    try { variants = JSON.parse(variantsEl.textContent); } catch(e){ variants = []; }
  }
  var colorImagesEl = document.getElementById('product-color-images-json');
  var colorImages = {};
  if(colorImagesEl){
    try { colorImages = JSON.parse(colorImagesEl.textContent); } catch(e){ colorImages = {}; }
  }

  function findVariant(colorValue, sizeValue){
    var colorIdx = productMeta.colorOptionIndex;
    var sizeIdx = productMeta.sizeOptionIndex;
    var optionKeys = ['option1', 'option2', 'option3'];
    for(var i = 0; i < variants.length; i++){
      var v = variants[i];
      var colorOk = colorIdx < 0 || !colorValue || (v[optionKeys[colorIdx]] && v[optionKeys[colorIdx]].toLowerCase() === colorValue.toLowerCase());
      var sizeOk = sizeIdx < 0 || !sizeValue || v[optionKeys[sizeIdx]] === sizeValue;
      if(colorOk && sizeOk){ return v; }
    }
    return null;
  }

  function formatMoney(cents){
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  var colorNames = { blanc:'Blanc', camel:'Camel', noir:'Noir', rouge:'Rouge' };
  var selectedSize = null;
  var selectedQty = 1;

  var swatches = document.querySelectorAll('.swatch-btn:not(.soon)');
  var note = document.getElementById('swatch-note');
  var mainImage = document.getElementById('main-product-image');
  var flatImage = document.getElementById('hero-flat-photo');
  var flatPending = document.getElementById('hero-flat-pending');
  var stickyPhoto = document.getElementById('sticky-photo');
  var activeSwatch = document.querySelector('.swatch-btn.active');
  var currentColor = activeSwatch ? activeSwatch.getAttribute('data-color') : null;

  function applyColorVisuals(colorValue){
    var wornUrl = colorImages[colorValue + '_worn'];
    var flatUrl = colorImages[colorValue + '_flat'];
    if(mainImage && wornUrl){ mainImage.src = wornUrl; }
    if(stickyPhoto && wornUrl){ stickyPhoto.style.backgroundImage = "url('" + wornUrl + "')"; }
    if(flatImage){
      if(flatUrl){
        flatImage.src = flatUrl;
        flatImage.style.display = 'block';
        if(flatPending){ flatPending.style.display = 'none'; }
      } else {
        flatImage.style.display = 'none';
        if(flatPending){ flatPending.style.display = 'flex'; }
      }
    }
  }

  swatches.forEach(function(btn){
    btn.addEventListener('click', function(){
      swatches.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      var c = btn.getAttribute('data-color');
      currentColor = c;
      var extra = c === 'blanc' ? ' — testé et approuvé, aucune transparence.' : '';
      if(note){ note.innerHTML = 'Couleur choisie : <strong>' + (colorNames[c] || c) + '</strong>' + extra; }
      applyColorVisuals(c);
      var stickyColorSelect = document.getElementById('sticky-color-select');
      if(stickyColorSelect){ stickyColorSelect.value = c; }
    });
  });

  /* red "coming soon" swatch -> scroll to the waitlist section */
  var soonBtn = document.querySelector('.swatch-btn.soon');
  if(soonBtn){
    soonBtn.addEventListener('click', function(){
      var target = document.getElementById('bientot-rouge');
      if(target){ target.scrollIntoView({behavior:'smooth', block:'center'}); }
      var emailInput = document.querySelector('#bientot-rouge input[type="email"]');
      if(emailInput){ setTimeout(function(){ emailInput.focus(); }, 400); }
    });
  }

  /* ---------- Size selector (hero) ---------- */
  var heroSizeBtns = document.querySelectorAll('#hero-sizes .size-btn');
  var heroSizeNote = document.getElementById('hero-size-note');
  heroSizeBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      heroSizeBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      selectedSize = btn.getAttribute('data-size');
      if(heroSizeNote){
        heroSizeNote.innerHTML = 'Taille sélectionnée : <strong>' + selectedSize + '</strong>';
        heroSizeNote.style.color = '';
      }
      updateCtaLabel();
      var stickySizeSelect = document.getElementById('sticky-size-select');
      if(stickySizeSelect){ stickySizeSelect.value = selectedSize; }
    });
  });

  /* ---------- Bundle selector ---------- */
  var bundleBtns = document.querySelectorAll('.bundle-btn');
  var ctaBtn = document.getElementById('cta-btn');
  function updateCtaLabel(){
    if(!ctaBtn) return;
    var active = document.querySelector('.bundle-btn.active');
    var qty = active ? active.getAttribute('data-qty') : '1';
    selectedQty = parseInt(qty, 10) || 1;
    var priceText = active ? active.querySelector('.p').textContent : ctaBtn.getAttribute('data-default-text');
    var label = qty + " L'Iconique";
    ctaBtn.textContent = 'Ajouter ' + label + ' — ' + priceText;
  }
  bundleBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      bundleBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      updateCtaLabel();
    });
  });

  /* ---------- Add to cart (real Shopify cart) ---------- */
  var cartMsg = document.getElementById('cart-msg');
  function updateHeaderCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var el = document.getElementById('header-cart-count');
      if(!el) return;
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }).catch(function(){});
  }
  function addToCart(variantId, quantity, onDone){
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function(res){ return res.json().then(function(data){ return { ok: res.ok, data: data }; }); })
      .then(function(result){ if(result.ok){ updateHeaderCartCount(); } onDone(result.ok, result.data); })
      .catch(function(){ onDone(false, null); });
  }

  if(ctaBtn){
    ctaBtn.addEventListener('click', function(){
      if(!selectedSize){
        if(heroSizeNote){
          heroSizeNote.innerHTML = "⚠️ Choisis ta taille avant d'ajouter au panier";
          heroSizeNote.style.color = 'var(--accent-text)';
        }
        var sizesEl = document.getElementById('hero-sizes');
        if(sizesEl){ sizesEl.scrollIntoView({behavior:'smooth', block:'center'}); }
        return;
      }
      var v = findVariant(currentColor, selectedSize);
      if(!v){
        if(cartMsg){ cartMsg.textContent = 'Cette combinaison couleur/taille n\'existe pas encore.'; cartMsg.className = 'cart-msg error'; }
        return;
      }
      if(v.available === false){
        if(cartMsg){ cartMsg.textContent = 'Cette taille est épuisée pour le moment.'; cartMsg.className = 'cart-msg error'; }
        return;
      }
      var originalText = ctaBtn.textContent;
      ctaBtn.textContent = ctaBtn.getAttribute('data-adding-text') || 'Ajout en cours…';
      ctaBtn.disabled = true;
      addToCart(v.id, selectedQty, function(ok, data){
        ctaBtn.disabled = false;
        if(ok){
          ctaBtn.textContent = '✅ Ajouté au panier';
          if(cartMsg){ cartMsg.textContent = "C'est dans ton panier ! Redirection..."; cartMsg.className = 'cart-msg success'; }
          window.location.href = '/cart';
        } else {
          ctaBtn.textContent = originalText;
          var msg = (data && data.description) ? data.description : "Un souci est survenu, réessaie.";
          if(cartMsg){ cartMsg.textContent = msg; cartMsg.className = 'cart-msg error'; }
        }
      });
    });
  }

  /* ---------- Secondary "mid-page" buy buttons -> scroll to hero and open size picker ---------- */
  document.querySelectorAll('.mid-cta').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var produit = document.getElementById('produit');
      if(produit){ produit.scrollIntoView({behavior:'smooth', block:'start'}); }
      setTimeout(function(){ if(ctaBtn){ ctaBtn.click(); } }, 450);
    });
  });

  /* ---------- Sticky bar: color/size selects + direct-to-checkout ---------- */
  var stickyColorSelect = document.getElementById('sticky-color-select');
  var stickySizeSelect = document.getElementById('sticky-size-select');
  if(stickyColorSelect){
    stickyColorSelect.value = currentColor || 'blanc';
    stickyColorSelect.addEventListener('change', function(){
      var target = document.querySelector('.swatch-btn[data-color="' + stickyColorSelect.value + '"]');
      if(target){ target.click(); }
    });
  }
  if(stickySizeSelect){
    stickySizeSelect.addEventListener('change', function(){
      if(!stickySizeSelect.value) return;
      var target = document.querySelector('#hero-sizes .size-btn[data-size="' + stickySizeSelect.value + '"]');
      if(target){ target.click(); }
    });
  }

  var stickyCtaBtn = document.getElementById('sticky-cta-btn');
  if(stickyCtaBtn){
    stickyCtaBtn.addEventListener('click', function(){
      var size = stickySizeSelect ? stickySizeSelect.value : selectedSize;
      var color = stickyColorSelect ? stickyColorSelect.value : currentColor;
      if(!size){
        if(stickySizeSelect){ stickySizeSelect.style.borderColor = 'var(--accent-deep)'; stickySizeSelect.focus(); }
        return;
      }
      var v = findVariant(color, size);
      if(!v || v.available === false){
        alert("Cette combinaison n'est pas disponible pour le moment.");
        return;
      }
      stickyCtaBtn.disabled = true;
      addToCart(v.id, 1, function(ok){
        stickyCtaBtn.disabled = false;
        if(ok){
          window.location.href = '/checkout';
        } else {
          alert("Un souci est survenu, réessaie.");
        }
      });
    });
  }

  /* ---------- Sticky bar visibility ---------- */
  var stickyBar = document.getElementById('sticky-bar');
  var heroImageEl = document.querySelector('.hero-image');
  if(stickyBar && heroImageEl && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      stickyBar.classList.toggle('show', !entries[0].isIntersecting);
    }, {rootMargin:'-80px 0px 0px 0px'});
    io.observe(heroImageEl);
  }

  /* ---------- Real "today" date, used by the free-shipping messages ---------- */
  (function(){
    var todayStr = new Date().toLocaleDateString('fr-FR', {weekday:'long', day:'numeric', month:'long'});
    ['free-ship-date', 'free-ship-date-hero', 'free-ship-date-sticky'].forEach(function(id){
      var el = document.getElementById(id);
      if(el){ el.textContent = todayStr; }
    });
  })();

  /* ---------- Delivery date estimate (business days, daily cutoff) ---------- */
  (function(){
    var el = document.getElementById('delivery-estimate');
    if(!el) return;
    var cutoffHour = parseInt((window.BossSecretSettings && window.BossSecretSettings.shippingCutoffHour) || 22, 10);
    var daysLow = parseInt((window.BossSecretSettings && window.BossSecretSettings.shippingDaysLow) || 3, 10);
    var daysHigh = parseInt((window.BossSecretSettings && window.BossSecretSettings.shippingDaysHigh) || 5, 10);
    function addBusinessDays(date, days){
      var d = new Date(date);
      var added = 0;
      while(added < days){
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if(day !== 0 && day !== 6){ added++; }
      }
      return d;
    }
    function fmt(d){ return d.toLocaleDateString('fr-FR', {weekday:'short', day:'numeric', month:'short'}); }
    var now = new Date();
    var base = new Date(now);
    if(now.getHours() >= cutoffHour){ base.setDate(base.getDate() + 1); }
    var low = addBusinessDays(base, daysLow);
    var high = addBusinessDays(base, daysHigh);
    el.innerHTML = '📦 Commande avant ' + cutoffHour + 'h aujourd\'hui : livraison estimée entre le <strong>' + fmt(low) + '</strong> et le <strong>' + fmt(high) + '</strong>.';
  })();

  /* ---------- Restock countdown (persisté par visiteuse) ---------- */
  (function(){
    var el = document.getElementById('restock-countdown');
    if(!el) return;
    var KEY = 'bs_restock_target';
    var target;
    try {
      var stored = localStorage.getItem(KEY);
      target = stored ? parseInt(stored, 10) : null;
    } catch(e){ target = null; }
    if(!target || isNaN(target)){
      target = Date.now() + 7 * 24 * 60 * 60 * 1000;
      try { localStorage.setItem(KEY, String(target)); } catch(e){}
    }
    function tick(){
      var diff = target - Date.now();
      if(diff <= 0){
        target = Date.now() + 7 * 24 * 60 * 60 * 1000;
        try { localStorage.setItem(KEY, String(target)); } catch(e){}
        diff = target - Date.now();
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      function pad(n){ return n < 10 ? '0' + n : n; }
      el.textContent = d + 'j ' + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-item').forEach(function(item){
    var q = item.querySelector('.faq-q');
    var a = item.querySelector('.faq-a');
    if(!q || !a) return;
    if(item.classList.contains('open')){ a.style.maxHeight = a.scrollHeight + 'px'; }
    q.addEventListener('click', function(){
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(it){
        it.classList.remove('open');
        it.querySelector('.faq-a').style.maxHeight = null;
      });
      if(!isOpen){
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  /* ---------- Size quiz modal ---------- */
  var quizModal = document.getElementById('quiz-modal');
  var openQuizBtn = document.getElementById('open-quiz');
  if(openQuizBtn && quizModal){
    openQuizBtn.addEventListener('click', function(){ quizModal.classList.add('open'); });
  }
  var heroQuizLink = document.getElementById('hero-size-quiz-link');
  if(heroQuizLink && quizModal){
    heroQuizLink.addEventListener('click', function(e){ e.preventDefault(); quizModal.classList.add('open'); });
  }
  var quizCloseBtn = document.getElementById('quiz-close');
  if(quizCloseBtn && quizModal){
    quizCloseBtn.addEventListener('click', function(){ quizModal.classList.remove('open'); });
    quizModal.addEventListener('click', function(e){ if(e.target === quizModal){ quizModal.classList.remove('open'); } });
  }
  var tabBtns = document.querySelectorAll('.tab-btn');
  tabBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      tabBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      var tab = btn.getAttribute('data-tab');
      document.querySelectorAll('.tab-panel').forEach(function(p){
        p.classList.toggle('active', p.getAttribute('data-panel') === tab);
      });
    });
  });

  /* Size quiz "conseil" form — shows the recommendation instantly, then sends the real signup in the background */
  var sizeQuizForm = document.getElementById('size-quiz-form');
  if(sizeQuizForm){
    sizeQuizForm.addEventListener('submit', function(e){
      var heightInput = document.getElementById('height-input');
      var result = document.getElementById('height-result');
      var h = heightInput ? parseFloat(heightInput.value) : NaN;
      if(!h || h < 140 || h > 210){
        e.preventDefault();
        if(result){ result.innerHTML = 'Indique ta taille en cm pour voir ton profil (par exemple 165).'; result.classList.add('show'); }
        return;
      }
      var email = document.getElementById('quiz-email-input');
      if(!email || !email.value || email.value.indexOf('@') === -1){
        e.preventDefault();
        if(result){ result.innerHTML = 'Indique ton email pour recevoir ta recommandation.'; result.classList.add('show'); }
        return;
      }
      var profile, size;
      if(h < 160){ profile = 'Petite'; size = 'XS / S'; }
      else if(h < 170){ profile = 'Standard'; size = 'S / M'; }
      else if(h < 180){ profile = 'Grande'; size = 'M / L'; }
      else { profile = 'Extra Grande'; size = 'L / XL'; }

      var weight = (document.getElementById('weight-input') || {}).value || '-';
      var usualSize = (document.getElementById('usual-size-input') || {}).value || '-';
      var sport = (document.getElementById('sport-input') || {}).value || '-';
      var diet = (document.getElementById('diet-input') || {}).value || '-';
      var work = (document.getElementById('work-input') || {}).value || '-';
      var noteInput = document.getElementById('quiz-note-input');
      if(noteInput){
        noteInput.value = 'Quiz taille — Taille:' + h + 'cm, Poids:' + weight + 'kg, Taille habituelle:' + usualSize +
          ', Sport:' + sport + ', Alimentation:' + diet + ', Travail:' + work + ', Profil calculé:' + profile;
      }

      var usualNote = (usualSize && usualSize !== '-') ? ' Comme tu fais habituellement du ' + usualSize + ", c'est cohérent avec ce profil." : '';
      if(result){
        result.innerHTML = 'Tu es dans notre profil <strong>' + profile + '</strong>. On te recommande de partir sur une taille <strong>' + size +
          "</strong> — entre deux tailles ? Prends toujours la taille au-dessus pour plus de confort." + usualNote +
          ' <em>(Recommandation indicative, à affiner avec notre tableau détaillé.)</em> On vient aussi de t\'envoyer ça par email.';
        result.classList.add('show');
      }

      /* Keep the visitor on the page: send the real signup to Shopify in the background */
      e.preventDefault();
      fetch(sizeQuizForm.action, { method: 'POST', body: new FormData(sizeQuizForm) }).catch(function(){});
    });
  }
  var directSizeBtns = document.querySelectorAll('.tab-panel[data-panel="direct"] .size-btn');
  directSizeBtns.forEach(function(btn){
    btn.addEventListener('click', function(){
      directSizeBtns.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      var result = document.getElementById('size-result');
      if(result){
        result.innerHTML = 'Tu as choisi la taille <strong>' + btn.getAttribute('data-size') + '</strong>.';
        result.classList.add('show');
      }
      var heroTarget = document.querySelector('#hero-sizes .size-btn[data-size="' + btn.getAttribute('data-size') + '"]');
      if(heroTarget){ heroTarget.click(); }
    });
  });

  /* ---------- Compat : libellés/raisons réutilisés par le popup "Trouve ton profil" ---------- */
  var colorReasons = {
    chaud:'les sous-tons chauds rayonnent dans les teintes terreuses et dorées.',
    froid:'les sous-tons froids adorent les contrastes nets et affirmés.',
    neutre:'les sous-tons neutres se marient avec (presque) tout — mais le blanc met particulièrement en valeur cet équilibre.'
  };
  var colorTargetLabel = { chaud:'camel', froid:'noir', neutre:'blanc' };

  /* ---------- Quiz couleur L'Iconique (5 questions, cf. brief marque) ---------- */
  (function(){
    var backdrop = document.getElementById('color-quiz-modal');
    if(!backdrop) return;
    var openBtn = document.getElementById('open-color-quiz');
    var closeBtn = document.getElementById('color-quiz-close');
    var steps = backdrop.querySelectorAll('.cq-step');
    var progressEl = document.getElementById('cq-progress');
    var current = 0;
    var cqAnswers = {};

    var CQ_ORDER = ['camel', 'noir', 'ivoire'];
    var CQ_WEIGHTS = {
      q1: { vertes:[2,0,1], bleu:[0,2,1], mixte:[1,1,1] },
      q2: { or:[2,0,1], argent:[0,2,1], deux:[1,1,1] },
      q3: { creme:[2,0,1], blanc:[0,2,2], deux:[1,1,1] },
      q4: { chaleureux:[3,0,1], puissant:[0,3,0], lumineux:[0,0,3] },
      q5: { effort:[3,0,1], affirmee:[0,3,0], lumineuse:[0,0,3] }
    };
    var CQ_COLOR_META = {
      camel: { name:'CAMEL', label:'LA SOLAIRE', desc:'Vos réponses montrent une affinité avec une allure chaleureuse, douce et sophistiquée.', productValue:'camel' },
      noir: { name:'NOIR', label:'LA CHARISMATIQUE', desc:'Vous êtes attirée par une silhouette affirmée, structurée et intemporelle.', productValue:'noir' },
      ivoire: { name:'IVOIRE', label:'LA LUMINEUSE', desc:'Vous recherchez une silhouette lumineuse, épurée et naturellement chic.', productValue:'blanc' }
    };

    function openModal(){ backdrop.classList.add('open'); }
    function closeModal(){ backdrop.classList.remove('open'); }
    function goTo(n){
      current = n;
      steps.forEach(function(s){ s.classList.toggle('active', parseInt(s.getAttribute('data-cq-step'), 10) === n); });
      if(progressEl){ progressEl.textContent = (n >= 1 && n <= 5) ? (n + '/5') : ''; }
    }

    if(openBtn){ openBtn.addEventListener('click', function(){ goTo(0); openModal(); }); }
    if(closeBtn){ closeBtn.addEventListener('click', closeModal); }
    backdrop.addEventListener('click', function(e){ if(e.target === backdrop){ closeModal(); } });

    backdrop.querySelectorAll('[data-cq-goto]').forEach(function(btn){
      btn.addEventListener('click', function(){ goTo(parseInt(btn.getAttribute('data-cq-goto'), 10)); });
    });

    function tieBreak(candidates, qKey){
      var answer = cqAnswers[qKey];
      var w = CQ_WEIGHTS[qKey] && CQ_WEIGHTS[qKey][answer];
      if(!w) return null;
      var bestVal = -1, best = [];
      candidates.forEach(function(k){
        var v = w[CQ_ORDER.indexOf(k)];
        if(v > bestVal){ bestVal = v; best = [k]; }
        else if(v === bestVal){ best.push(k); }
      });
      return best.length === 1 ? best[0] : null;
    }

    function computeResult(){
      var s = { camel:0, noir:0, ivoire:0 };
      Object.keys(cqAnswers).forEach(function(q){
        var w = CQ_WEIGHTS[q] && CQ_WEIGHTS[q][cqAnswers[q]];
        if(!w) return;
        s.camel += w[0]; s.noir += w[1]; s.ivoire += w[2];
      });
      var max = Math.max(s.camel, s.noir, s.ivoire);
      var winners = CQ_ORDER.filter(function(k){ return s[k] === max; });
      var primary;
      if(winners.length === 1){
        primary = winners[0];
      } else {
        primary = tieBreak(winners, 'q5') || tieBreak(winners, 'q4') || 'neutre';
      }
      var second = null;
      if(primary !== 'neutre'){
        var rest = CQ_ORDER.filter(function(k){ return k !== primary; });
        rest.sort(function(a, b){ return s[b] - s[a]; });
        second = rest[0];
      }
      return { scores:s, primary:primary, second:second, tied: primary === 'neutre' ? winners : null };
    }

    function showResult(){
      var result = computeResult();
      var titleEl = document.getElementById('cq-result-title');
      var descEl = document.getElementById('cq-result-desc');
      var secondEl = document.getElementById('cq-result-second');
      var ctaEl = document.getElementById('cq-result-cta');
      var noteInput = document.getElementById('cq-email-note');
      var primaryColorValue = 'camel';

      if(result.primary === 'neutre'){
        var tiedNames = result.tied.map(function(k){ return CQ_COLOR_META[k].name; }).join(' & ');
        if(titleEl){ titleEl.textContent = tiedNames; }
        if(descEl){ descEl.textContent = "Votre profil se partage naturellement entre ces deux couleurs — les deux vous mettront en valeur, laissez votre envie du jour trancher."; }
        if(secondEl){ secondEl.textContent = ''; }
        if(ctaEl){ ctaEl.textContent = "Découvrir L'Iconique →"; }
        primaryColorValue = CQ_COLOR_META[result.tied[0]].productValue;
      } else {
        var meta = CQ_COLOR_META[result.primary];
        if(titleEl){ titleEl.textContent = meta.name + ' — ' + meta.label; }
        if(descEl){ descEl.textContent = meta.desc; }
        if(secondEl && result.second){ secondEl.textContent = 'Deuxième choix : ' + CQ_COLOR_META[result.second].name; }
        if(ctaEl){ ctaEl.textContent = "Découvrir L'Iconique " + meta.name + ' →'; }
        primaryColorValue = meta.productValue;
      }

      if(noteInput){
        noteInput.value = 'Quiz couleur v2 — Q1:' + (cqAnswers.q1 || '-') + ', Q2:' + (cqAnswers.q2 || '-') + ', Q3:' + (cqAnswers.q3 || '-') +
          ', Q4:' + (cqAnswers.q4 || '-') + ', Q5:' + (cqAnswers.q5 || '-') + ', Résultat:' + result.primary +
          ', Scores: camel=' + result.scores.camel + ' noir=' + result.scores.noir + ' ivoire=' + result.scores.ivoire;
      }

      backdrop.setAttribute('data-cq-result-color', primaryColorValue);
      goTo(6);
    }

    backdrop.querySelectorAll('.cq-choice').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.closest('[data-cq-question]');
        var q = group.getAttribute('data-cq-question');
        cqAnswers[q] = btn.getAttribute('data-cq-value');
        group.querySelectorAll('.cq-choice').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var step = btn.closest('.cq-step');
        var stepNum = parseInt(step.getAttribute('data-cq-step'), 10);
        if(stepNum < 5){ goTo(stepNum + 1); } else { showResult(); }
      });
    });

    var emailForm = document.getElementById('cq-email-form');
    if(emailForm){
      emailForm.addEventListener('submit', function(e){
        var emailInput = document.getElementById('cq-email-input');
        if(!emailInput || !emailInput.value || emailInput.value.indexOf('@') === -1){ return; }
        e.preventDefault();
        fetch(emailForm.action, { method: 'POST', body: new FormData(emailForm) }).catch(function(){});
        var submitBtn = document.getElementById('cq-email-submit');
        if(submitBtn){ submitBtn.textContent = '✓ Guide envoyé'; submitBtn.disabled = true; }
      });
    }

    var restartBtn = document.getElementById('cq-restart');
    if(restartBtn){
      restartBtn.addEventListener('click', function(){
        cqAnswers = {};
        backdrop.querySelectorAll('.cq-choice.active').forEach(function(b){ b.classList.remove('active'); });
        var emailInput = document.getElementById('cq-email-input');
        if(emailInput){ emailInput.value = ''; }
        var submitBtn = document.getElementById('cq-email-submit');
        if(submitBtn){ submitBtn.textContent = 'RECEVOIR MON GUIDE'; submitBtn.disabled = false; }
        goTo(0);
      });
    }

    var resultCta = document.getElementById('cq-result-cta');
    if(resultCta){
      resultCta.addEventListener('click', function(){
        var colorValue = backdrop.getAttribute('data-cq-result-color') || 'camel';
        closeModal();
        var targetSwatch = document.querySelector('.swatch-btn[data-color="' + colorValue + '"]');
        if(targetSwatch){ targetSwatch.click(); }
        var productEl = document.getElementById('produit');
        if(productEl){ productEl.scrollIntoView({ behavior:'smooth', block:'start' }); }
      });
    }
  })();

  /* ---------- Popup "Trouve ton profil" (colorimétrie + taille, email avant résultat) ---------- */
  (function(){
    var backdrop = document.getElementById('style-quiz-popup');
    if(!backdrop) return;
    var settings = window.BossSecretQuizPopup || { delaySeconds: 8, hideDays: 14 };
    var KEY = 'bs_quiz_popup_state';

    var closeBtn = document.getElementById('style-quiz-close');
    var skipBtn = document.getElementById('style-quiz-skip-intro');
    var steps = backdrop.querySelectorAll('.popup-step');
    var dots = backdrop.querySelectorAll('.popup-progress-dot');
    var current = 0;
    var popupToneScore = { chaud:0, froid:0, neutre:0 };
    var computedSize = '';
    var computedColorKey = '';

    function readSnooze(){
      try {
        var raw = localStorage.getItem(KEY);
        if(!raw) return null;
        return JSON.parse(raw);
      } catch(e){ return null; }
    }
    function writeSnooze(state, days){
      try {
        var until = days ? (Date.now() + days * 24 * 60 * 60 * 1000) : null;
        localStorage.setItem(KEY, JSON.stringify({ state: state, until: until }));
      } catch(e){}
    }
    function shouldShow(){
      var saved = readSnooze();
      if(!saved) return true;
      if(saved.state === 'completed') return false;
      if(saved.until && Date.now() < saved.until) return false;
      return true;
    }

    function openPopup(){
      backdrop.classList.add('open');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    function closePopup(snoozeDays){
      backdrop.classList.remove('open');
      backdrop.setAttribute('aria-hidden', 'true');
      if(typeof snoozeDays !== 'undefined'){ writeSnooze('dismissed', snoozeDays); }
    }
    function goToStep(n){
      current = n;
      steps.forEach(function(s){ s.classList.toggle('active', parseInt(s.getAttribute('data-step'), 10) === n); });
      dots.forEach(function(d){
        var ds = parseInt(d.getAttribute('data-step'), 10);
        d.classList.toggle('active', ds === Math.min(n, 4));
        d.classList.toggle('done', ds < n && ds <= 4);
      });
    }

    if(closeBtn){ closeBtn.addEventListener('click', function(){ closePopup(settings.hideDays); }); }
    if(skipBtn){ skipBtn.addEventListener('click', function(){ closePopup(settings.hideDays); }); }
    backdrop.addEventListener('click', function(e){
      if(e.target === backdrop && current !== 6){ closePopup(settings.hideDays); }
    });

    backdrop.querySelectorAll('[data-next]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var step = btn.closest('.popup-step');
        var stepNum = parseInt(step.getAttribute('data-step'), 10);
        if(stepNum === 3){
          var h = parseFloat((document.getElementById('popup-height') || {}).value);
          var errEl = document.getElementById('popup-step3-error');
          if(!h || h < 140 || h > 210){
            if(errEl) errEl.textContent = 'Indique ta taille en cm pour continuer (par exemple 165).';
            return;
          }
          if(errEl) errEl.textContent = '';
          var w = parseFloat((document.getElementById('popup-weight') || {}).value) || null;
          computedSize = computePopupSize(h, w);
        }
        goToStep(stepNum + 1);
      });
    });

    backdrop.querySelectorAll('.tone-swatch').forEach(function(btn){
      btn.addEventListener('click', function(){
        var group = btn.getAttribute('data-group');
        var weight = (group === 'tone1') ? 2 : 1;
        popupToneScore[btn.getAttribute('data-tone')] += weight;
        var step = btn.closest('.popup-step');
        var stepNum = parseInt(step.getAttribute('data-step'), 10);
        goToStep(stepNum + 1);
      });
    });

    function computePopupSize(h, w){
      var order = ['XS','S','M','L','XL'];
      var idx;
      if(h <= 158) idx = 0;
      else if(h <= 165) idx = 1;
      else if(h <= 172) idx = 2;
      else if(h <= 179) idx = 3;
      else idx = 4;
      if(w && h){
        var bmi = w / Math.pow(h / 100, 2);
        if(bmi < 19 && idx > 0) idx -= 1;
        if(bmi > 27 && idx < order.length - 1) idx += 1;
      }
      return order[idx];
    }

    function computePopupColor(){
      var winner = 'neutre';
      if(popupToneScore.chaud >= popupToneScore.froid && popupToneScore.chaud >= popupToneScore.neutre){ winner = 'chaud'; }
      else if(popupToneScore.froid >= popupToneScore.chaud && popupToneScore.froid >= popupToneScore.neutre){ winner = 'froid'; }
      return winner;
    }

    var popupForm = document.getElementById('style-quiz-form');
    if(popupForm){
      popupForm.addEventListener('submit', function(e){
        e.preventDefault();
        var emailInput = document.getElementById('popup-email');
        var errEl = document.getElementById('popup-email-error');
        if(!emailInput || !emailInput.value || emailInput.value.indexOf('@') === -1){
          if(errEl) errEl.textContent = 'Indique un email valide pour débloquer ton profil.';
          return;
        }
        if(errEl) errEl.textContent = '';

        var winner = computePopupColor();
        computedColorKey = colorTargetLabel[winner];
        var colorLabel = colorNames[computedColorKey] || computedColorKey;
        var work = (document.getElementById('popup-work') || {}).value || '-';
        var sport = (document.getElementById('popup-sport') || {}).value || '-';
        var height = (document.getElementById('popup-height') || {}).value || '-';
        var weight = (document.getElementById('popup-weight') || {}).value || '-';

        var noteInput = document.getElementById('popup-note-input');
        if(noteInput){
          noteInput.value = 'Quiz popup profil — Taille:' + height + 'cm, Poids:' + weight + 'kg, Taille conseillée:' + computedSize +
            ', Couleur conseillée:' + colorLabel + ', Sous-ton:' + winner + ', Travail:' + work + ', Sport:' + sport;
        }

        /* Envoi en tâche de fond, sans recharger la page */
        fetch(popupForm.action, { method: 'POST', body: new FormData(popupForm) }).catch(function(){});

        var sizeEl = document.getElementById('popup-result-size');
        var colorNameEl = document.getElementById('popup-result-color');
        var colorDotEl = document.getElementById('popup-result-color-dot');
        var reasonEl = document.getElementById('popup-result-reason');
        var colorDots = { blanc:'#FBF8F2', camel:'#C19A6B', noir:'#232323' };
        if(sizeEl) sizeEl.textContent = computedSize;
        if(colorNameEl) colorNameEl.textContent = colorLabel;
        if(colorDotEl) colorDotEl.style.background = colorDots[computedColorKey] || '#CCCCCC';
        if(reasonEl) reasonEl.textContent = (colorReasons[winner] || '') + ' Ta morphologie t\'oriente naturellement vers la taille ' + computedSize + '.';

        writeSnooze('completed');
        goToStep(6);
      });
    }

    var resultCta = document.getElementById('popup-result-cta');
    var resultErrorEl = document.getElementById('popup-result-error');
    if(resultCta){
      resultCta.addEventListener('click', function(){
        if(resultErrorEl){ resultErrorEl.textContent = ''; }
        var v = findVariant(computedColorKey, computedSize);
        if(!v || v.available === false){
          /* Combinaison indisponible : on préremplit quand même la fiche produit et on y emmène la cliente */
          closePopup();
          var targetSwatch = document.querySelector('.swatch-btn[data-color="' + computedColorKey + '"]');
          if(targetSwatch){ targetSwatch.click(); }
          var targetSize = document.querySelector('#hero-sizes .size-btn[data-size="' + computedSize + '"]');
          if(targetSize){ targetSize.click(); }
          var productEl = document.getElementById('produit');
          if(productEl){ productEl.scrollIntoView({ behavior:'smooth', block:'start' }); }
          return;
        }
        var originalText = resultCta.textContent;
        resultCta.textContent = resultCta.getAttribute('data-adding-text') || 'Ajout en cours…';
        resultCta.disabled = true;
        addToCart(v.id, 1, function(ok, data){
          if(ok){
            window.location.href = '/cart';
            return;
          }
          resultCta.disabled = false;
          resultCta.textContent = originalText;
          var msg = (data && data.description) ? data.description : 'Un souci est survenu, réessaie.';
          if(resultErrorEl){ resultErrorEl.textContent = msg; }
        });
      });
    }

    if(shouldShow()){
      setTimeout(openPopup, Math.max(1, settings.delaySeconds) * 1000);
    }
  })();

  /* ---------- Live chat widget (aperçu — non connecté) ---------- */
  var chatBubble = document.getElementById('chat-bubble');
  var chatPanel = document.getElementById('chat-panel');
  var chatClose = document.getElementById('chat-close');
  var chatBody = document.getElementById('chat-body');
  var chatForm = document.getElementById('chat-form');
  var chatInput = document.getElementById('chat-input');
  var chatReplies = [
    'Merci pour ton message ! Notre équipe te répond généralement en quelques minutes.',
    'Bonne question — tu trouveras le guide des tailles juste au-dessus, avec un quiz pour être sûre de ton choix.',
    'On livre partout en Europe en 3 à 5 jours, retours gratuits sous 30 jours si besoin !',
    "Je transmets ça à l'équipe, on revient vers toi par email très vite."
  ];
  function addChatMsg(text, who){
    var div = document.createElement('div');
    div.className = 'chat-msg ' + (who === 'user' ? 'chat-msg-user' : 'chat-msg-bot');
    div.textContent = text;
    chatBody.appendChild(div);
    chatBody.scrollTop = chatBody.scrollHeight;
  }
  if(chatBubble && chatPanel){
    chatBubble.addEventListener('click', function(){
      chatPanel.classList.toggle('open');
      if(chatPanel.classList.contains('open') && chatInput){ chatInput.focus(); }
    });
    if(chatClose){ chatClose.addEventListener('click', function(){ chatPanel.classList.remove('open'); }); }
  }
  if(chatForm){
    chatForm.addEventListener('submit', function(e){
      e.preventDefault();
      var val = chatInput.value.trim();
      if(!val) return;
      addChatMsg(val, 'user');
      chatInput.value = '';
      setTimeout(function(){
        addChatMsg(chatReplies[Math.floor(Math.random() * chatReplies.length)], 'bot');
      }, 700);
    });
  }

  /* ---------- Page panier : timer offre flash + gestion des lignes ---------- */
  (function(){
    var timerEl = document.getElementById('cart-flash-timer');
    var bannerEl = document.getElementById('cart-flash-banner');
    if(timerEl){
      var KEY = 'bs_cart_flash_deadline';
      var deadline;
      try {
        var stored = sessionStorage.getItem(KEY);
        deadline = stored ? parseInt(stored, 10) : null;
      } catch(e){ deadline = null; }
      if(!deadline || isNaN(deadline)){
        deadline = Date.now() + 10 * 60 * 1000;
        try { sessionStorage.setItem(KEY, String(deadline)); } catch(e){}
      }
      function tickFlash(){
        var diff = deadline - Date.now();
        if(diff <= 0){
          if(bannerEl){
            bannerEl.querySelector('.cart-flash-msg').innerHTML = 'Les <strong>-10&euro; supplémentaires</strong> restent appliqués à votre commande — finalisez quand vous êtes prête.';
          }
          return;
        }
        var m = Math.floor(diff / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        function pad(n){ return n < 10 ? '0' + n : n; }
        timerEl.textContent = m + ':' + pad(s);
        setTimeout(tickFlash, 1000);
      }
      tickFlash();
    }

    var cartLines = document.querySelectorAll('.cart-line');
    if(cartLines.length){
      function changeLine(line, quantity){
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        }).then(function(){ window.location.reload(); }).catch(function(){});
      }
      document.querySelectorAll('.cart-qty-btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          var line = parseInt(btn.getAttribute('data-line'), 10);
          var delta = parseInt(btn.getAttribute('data-delta'), 10);
          var valueEl = btn.closest('.cart-line-qty-row').querySelector('.cart-qty-value');
          var current = parseInt(valueEl.textContent, 10) || 1;
          var next = Math.max(0, current + delta);
          btn.disabled = true;
          changeLine(line, next);
        });
      });
      document.querySelectorAll('.cart-remove-btn').forEach(function(btn){
        btn.addEventListener('click', function(){
          var line = parseInt(btn.getAttribute('data-line'), 10);
          btn.disabled = true;
          changeLine(line, 0);
        });
      });
    }
  })();

  /* ---------- Lazy autoplay for feature videos (perf) ---------- */
  (function(){
    var lazyVideos = document.querySelectorAll('video.lazy-video');
    if(!lazyVideos.length) return;
    if(!('IntersectionObserver' in window)){
      lazyVideos.forEach(function(v){
        var src = v.querySelector('source');
        if(src && src.dataset.src){ src.src = src.dataset.src; v.load(); v.play().catch(function(){}); }
      });
      return;
    }
    var vio = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        var v = entry.target;
        var src = v.querySelector('source');
        if(src && src.dataset.src && !src.src){
          src.src = src.dataset.src;
          v.load();
          v.play().catch(function(){});
        }
        obs.unobserve(v);
      });
    }, { rootMargin: '200px 0px' });
    lazyVideos.forEach(function(v){ vio.observe(v); });
  })();

  /* ---------- Click-to-zoom on content photos ---------- */
  (function(){
    var zoomSelector = '.hero-image img, .feature-card img, .split img, .avis-card img, .mosaic-tile img, .versatility-frame img';
    var overlay = document.createElement('div');
    overlay.className = 'zoom-lightbox';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '<button type="button" class="zoom-lightbox-close" aria-label="Fermer">✕</button><img alt="">';
    document.body.appendChild(overlay);
    var overlayImg = overlay.querySelector('img');
    var closeBtn = overlay.querySelector('.zoom-lightbox-close');
    function openZoom(src, alt){
      if(!src) return;
      overlayImg.src = src;
      overlayImg.alt = alt || '';
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    function closeZoom(){
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
    }
    document.addEventListener('click', function(e){
      var img = e.target.closest(zoomSelector);
      if(img){ openZoom(img.currentSrc || img.src, img.alt); }
    });
    closeBtn.addEventListener('click', closeZoom);
    overlay.addEventListener('click', function(e){ if(e.target === overlay){ closeZoom(); } });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeZoom(); } });
  })();

  /* ---------- Subtle 3D tilt on product photos and feature cards ---------- */
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!prefersReducedMotion){
    document.querySelectorAll('.hero-image, .feature-card').forEach(function(el){
      el.style.transformStyle = 'preserve-3d';
      el.style.willChange = 'transform';
      el.addEventListener('mousemove', function(e){
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(700px) rotateY(' + (px * 8) + 'deg) rotateX(' + (py * -8) + 'deg) scale(1.015)';
      });
      el.addEventListener('mouseleave', function(){
        el.style.transform = 'perspective(700px) rotateY(0) rotateX(0) scale(1)';
      });
    });
  }
})();
